import React from "react";

import styled from "styled-components";

import {
  SpaceComponentObject,
  FunctionAttributeNode,
  SourceType
} from "../../../../../../types";
import PermissionFeedback from "../PermissionFeedback";
import { useAccess } from "../useFunctionAccess";
import { ViewResult } from "../useView";
import { getUsedFunctionParameters } from "../util";

const Title = styled.span<{ fontSize?: string }>`
  ${props => (props.fontSize ? `font-size: ${props.fontSize};` : "")}
`;

interface ViewComponentTitleProps {
  component: SpaceComponentObject;
  viewResult: ViewResult;
  fontSize?: string;
}

export default function ViewComponentTitle({
  fontSize,
  component,
  viewResult
}: ViewComponentTitleProps) {
  const access = useAccess(viewResult.viewFunction?.access);

  return (
    <>
      <Title fontSize={fontSize}>{component.properties.title || ""}</Title>
      {viewResult.sourceType === SourceType.VIEW && (
        <PermissionFeedback
          attributes={viewResult.attributes as FunctionAttributeNode[]}
          parameters={
            viewResult.viewFunction
              ? getUsedFunctionParameters(
                  viewResult.viewFunction,
                  component.properties.input_parameters
                )
              : []
          }
          access={access}
        />
      )}
    </>
  );
}
